<div class="w-full" *ngIf="mergedConfig.showButton">
  <div class="relative m-4">
    <div class="flex w-full justify-between">
      <!-- Main Settings Button -->
      <button
        mat-flat-button
        class="flex w-full justify-start bg-gray-100 dark:bg-slate-600"
        [class.rounded-r-md]="!hasToggle"
        (click)="openSettings()">
        <mat-icon [svgIcon]="mergedConfig.settingsIcon"></mat-icon>
        <span class="ml-2">{{ mergedConfig.settingsLabel }}</span>
        <mat-icon
          *ngIf="mergedConfig.openInNewWindow"
          [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"
          class="absolute icon-size-4 right-4"></mat-icon>
      </button>

      <!-- Toggle (Kebab) Menu Button -->
      <button *ngIf="hasToggle" class="p-2" [matMenuTriggerFor]="settingsMenu" #menuTrigger="matMenuTrigger">
        <mat-icon [svgIcon]="'heroicons_outline:chevron-down'" [class.rotate-180]="menuTrigger.menuOpen"></mat-icon>
      </button>
    </div>

    <!-- Toggle Menu Items -->
    <mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
      <button
        *ngFor="let item of mergedConfig.toggleButtonMenuItems; trackBy: trackByFn"
        mat-menu-item
        (click)="onMenuItemClick(item)">
        <mat-icon *ngIf="item.icon" [svgIcon]="item.icon" class="mr-2"></mat-icon>
        <span>{{ item.label }}</span>
      </button>
    </mat-menu>
  </div>
</div>
